import React, { useState } from 'react';
export default function ContentImage({ src, alt, className = '', ...props }) {
    const [failedSrc, setFailedSrc] = useState(null);
    if (!src || failedSrc === src) return <div className={`image-placeholder ${className}`} role="img" aria-label={alt}><span aria-hidden="true">◌</span><small>Fotografie není dostupná</small></div>;
    return <img src={src} alt={alt} className={className} {...props} onError={() => setFailedSrc(src)} />;
}
